import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modalagregar from "../../componentes/GeneralComponents/ModalDetalle";
import { buySubscription_request, cancelSubscription_request, getSubscriptionTickets_request } from "../../services/suscripcion_services";
import { addTarjeta_request, defaultCard_request, deleteTarjeta_request, getTarjetas_request } from "../../services/metodosPago_services";
import { infoUser_request } from "../../services/perfil_services";
import { Button, Empty, Input, Modal, Popover, Row } from "antd";
import NewNavbar from "../../componentes/GeneralComponents/Navbar_Nuevo";
import { Content } from "antd/es/layout/layout";
import { Loader } from "../../componentes/GeneralComponents/Loader";
import ButtonAntd from "../../componentes/GeneralComponents/ButtonAntd";
import { AddCard, Close, ExpandMore, Help } from "@mui/icons-material";
import ResibosCard from "../../componentes/Metodos-Pagos/RecibosCard";
import LoaderModals from "../../componentes/GeneralComponents/Loader_modals";
import InputAntd from "../../componentes/GeneralComponents/InputAntd";
import SelectAntd from "../../componentes/GeneralComponents/SelectAntd";
import { Boton, LeyendaError } from "../../componentes/GeneralComponents/Formularios";
import TarjetasCard from "../../componentes/Metodos-Pagos/tarjetasCard";
import { SnackbarProvider } from "notistack";
import SnackBar from "../../componentes/GeneralComponents/Snackbar";
import { UseModal } from "../../hooks/UseModal";
import { showSnackbar } from "../../redux/snackbarSlice";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import visa from "../../Img/visa-svg.svg";
import mastercard from "../../Img/mastercard-svg.svg";
import Logo from "../../logo.svg";
import "../styles/Suscripcion.scss";

export default function Suscripcion() {
    const dispatch = useDispatch();

    const expresiones = {
        Numeros: /^[0-9]{1,16}$/, // numeros.
    };

    const infoUser = useSelector((state) => state.userInfo.usuario);

    const styleAgregarT = {
        height: "clac(100vh - 52px)",
        width: "clac(100vw - 52px)",
        margin: "0 2%",
    };

    const [isOpenAgregarT, OpenAgregarT, CloseAgregarT] = UseModal(false);
    const [isOpenSelecTarjeta, OpenSelecTarjeta, CloseSelecTarjeta] = UseModal(false);
    const [ModalStatusCancelSub, setModalStatusCancelSub] = useState(false);

    const [TarjetasList, setTarjetasList] = useState([]);
    const [RecibosList, setRecibosList] = useState([]);
    const [IdTarjeta, setIdTarjeta] = useState("");
    const [TarjPredetermindada, setTarjPredetermindada] = useState("");

    const [NumeroTarjeta, setNumeroTarjeta] = useState("");
    const [ExpiracionMes, setExpiracionMes] = useState(null);
    const [ExpiracionYear, setExpiracionYear] = useState("");
    const [CVV, setCVV] = useState("");

    const [open, setOpen] = useState(false);
    const [typeMessage, setTypeMessage] = useState("");
    const [message, setMessage] = useState("");

    const [MensajeNumeroTarjeta, setMensajeNumeroTarjeta] = useState("true");
    const [MensajeExpiracion, setMensajeExpiracion] = useState("true");
    const [MensajeCVV, setMensajeCVV] = useState("true");

    const [loader, setLoader] = useState(false);
    const [loaderModal, setLoaderModal] = useState(false);

    async function getRecibos() {
        setLoader(true);
        let response = await getSubscriptionTickets_request();
        if (response.ok) {
            // console.log(response.data);
            setRecibosList(response.data);
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
        setLoader(false);
        return;
    }

    async function getTarjetas() {
        setLoader(true);
        let response = await getTarjetas_request();
        if (response.ok) {
            // console.log(response.data);
            setTarjetasList(response.data);
            response.data.forEach(Tarjeta => {
                if (Tarjeta.Predeterminado === 1) {
                    setTarjPredetermindada(Tarjeta);
                }
            });
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
        setLoader(false);
        return;
    }

    async function saveTarjeta(e) {
        e.preventDefault();
        setLoaderModal(true);
        if (
            !!NumeroTarjeta &&
            MensajeNumeroTarjeta !== "false" &&
            !!ExpiracionMes &&
            !!ExpiracionYear &&
            MensajeExpiracion !== "false" &&
            !!CVV &&
            MensajeCVV !== "false" &&
            NumeroTarjeta.length === 16
        ) {
            let data = new FormData();

            data.append("Number", NumeroTarjeta);
            data.append("Fecha", `${ExpiracionMes}/${ExpiracionYear}`);
            data.append("Cvc", CVV);

            let response = await addTarjeta_request(data);
            if (response.ok) {
                setOpen(true);
                setTypeMessage("success");
                setMessage("Tarjeta agregada");
                getTarjetas();
                CloseAgregarT(true);
            } else {
                setOpen(true);
                setTypeMessage("error");
                setMessage(response.mensaje);
            }
        } else {
            if (!!!NumeroTarjeta || NumeroTarjeta.length < 16) {
                setMensajeNumeroTarjeta("false");
            }
            if (!!!ExpiracionMes || !!!ExpiracionYear) {
                setMensajeExpiracion("false");
            }
            if (!!!CVV) {
                setMensajeCVV("false");
            }

            setOpen(true);
            setTypeMessage("warning");
            setMessage("Faltan campos por completar");
        }
        setLoaderModal(false);
        return;
    }

    async function deleteTarjeta() {
        setLoader(true);
        let response = await deleteTarjeta_request(IdTarjeta);
        if (response.ok) {
            setOpen(true);
            setTypeMessage("success");
            setMessage("Tarjeta eliminada");
            getTarjetas();
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
        setLoader(false);
        return;
    }

    async function selectDefaultCard() {
        let response = await defaultCard_request(IdTarjeta);

        if (response.ok) {
            setOpen(true);
            setTypeMessage("success");
            setMessage("Nuevo metodo de pago seleccionado");
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
    }

    async function PaySubscription() {
        if (TarjetasList.length === 0) {
            dispatch(showSnackbar({
                show: true,
                text: "Debe agregar un método de pago",
                type: "warning",
            }));
            return;
        }
        setLoader(true);
        const tarjetaPredeterminada = TarjetasList.find(t => t.Predeterminado === 1);
        let data = new FormData();
        data.append("tarjeta", tarjetaPredeterminada.IdTarjeta);
        let response = await buySubscription_request(data);
        if (response.ok) {
            dispatch(showSnackbar({
                show: true,
                text: "Pago completado",
                type: "success",
            }));
            getInfoUser();
        } else {
            dispatch(showSnackbar({
                show: true,
                text: response.mensaje,
                type: "error",
            }));
        }
        setLoader(false);
        return;
    }

    async function getInfoUser() {
        let response = await infoUser_request();
        if (response["ok"]) {
            dispatch(infoUser(response.data));
            let info = response.data.Usuario;
            sessionStorage.setItem("infoUser", JSON.stringify(info));
        } else {
            dispatch(showSnackbar({
                show: true,
                text: response.mensaje,
                type: "error",
            }));
        }
        return;
    }

    async function cancelSub() {
        setLoader(true);
        let response = await cancelSubscription_request();
        if (response.ok) {
            dispatch(showSnackbar({
                show: true,
                text: "Suscripción cancelada",
                type: "success",
            }));
        } else {
            dispatch(showSnackbar({
                show: true,
                text: response.mensaje,
                type: "error",
            }));
        }
        setLoader(false);
        return;
    }

    const [modal, ModalCancelSub] = Modal.useModal();
    const confirm = () => {
        modal.confirm({
            title: "¿Desea cancelar su suscripción?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            onOk: () => cancelSub(),
            onCancel: () => setModalStatusCancelSub(false),
            open: ModalStatusCancelSub,
            icon: <ExclamationCircleOutlined />,
            content: (
                <div>
                    <p>Al cancelar su suscripción, perderá acceso a su cuenta un día después de la fecha en que se realizaría su próxima renovación</p>
                </div>
            ),
        });
    };

    useEffect(() => {
        getTarjetas();
        getRecibos();
        return;
    }, []);
    return (
        <Stack>
            <NewNavbar
                showBanner={false}
                mensajesError={{
                    setOpen: setOpen,
                    setTypeMessage: setTypeMessage,
                    setMessage: setMessage,
                }}
                modulo={"Suscripcion"}
            />

            <Content
                className="site-layout"
                style={{
                    padding: "0 3%",
                    width: "100%",
                    overflow: "initial",
                }}
            >
                {loader ? (
                    <Loader />
                ) : (
                    <>
                        <Row style={{ width: "100%", margin: "1% 0", display: "flex", justifyContent: "space-between" }}>
                            <div
                                className="AliniarLeftMembresia"

                            >
                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <img style={{ width: "70px" }} src={Logo} alt="" />
                                    {infoUser.Paquete === "2" && infoUser.PaqueteStatus === 1 ? <Popover
                                        title="Detalle de suscripción IOS"
                                        content={
                                            <div style={{ width: "200px" }}>
                                                <p>Suscripción contratada por medio de IOS, en caso de requerir una cancelacion, debera realizarlo desde un dispositivo IOS con su Apple id</p>
                                            </div>
                                        }
                                    >
                                        <Help sx={{ color: "#148f9f" }} />
                                    </Popover> : <Button onClick={() => {
                                        if (TarjetasList.length > 0) {
                                            if (infoUser.Paquete === "1" && infoUser.PaqueteStatus === 1) {
                                                confirm();
                                            } else {
                                                PaySubscription();
                                            }
                                        } else {
                                            OpenAgregarT(true);
                                        }
                                    }} style={{ background: "#148f9f", color: "#fff" }}>
                                        {infoUser.Paquete === "1" && infoUser.PaqueteStatus === 1 ? "Cancelar" : "Renovar"}
                                    </Button>}
                                </div>
                                <div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", margin: "1% 0" }}>
                                        <p style={{ fontWeight: "500" }}>
                                            Mi plan{" "}
                                            <span style={{ color: "#148f9f" }}>Ygia Superior</span>
                                        </p>
                                        <p style={{ fontWeight: "500" }}>$599.00 al mes.</p>
                                    </div>

                                    {/* <p>
                        Este es el plan gratuito que cuenta con 2 meses de
                        vigencia.
                      </p> */}

                                </div>
                                <div style={{ margin: "1% 0" }}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMore />} l>
                                            <Typography>
                                                Informacion general sobre mi plan
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1% 0", borderBottom: "1px solid #d7d7d7" }}>
                                                <div>Funcionalidades básicas</div>
                                                <div>Ilimitado</div>
                                            </Row>
                                            <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1% 0", borderBottom: "1px solid #d7d7d7" }}>
                                                <div>Consultorio</div>
                                                <div>Ilimitado</div>
                                            </Row>
                                            <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1% 0", borderBottom: "1px solid #d7d7d7" }}>
                                                <div>Expediente médico electrónico</div>
                                                <div>Ilimitado</div>
                                            </Row>
                                            <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1% 0", borderBottom: "1px solid #d7d7d7" }}>
                                                <div>Administración de agenda</div>
                                                <div>Ilimitado</div>
                                            </Row>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>

                            </div>
                            <div
                                className="AliniarightMembresia"
                            >
                                <Row style={{ width: "100%", color: "#424242", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                                    <div>
                                        <h3>Domiciliar pago</h3>
                                        <u style={{ color: "#148f9f", cursor: "pointer" }} onClick={OpenSelecTarjeta}>Cambiar método de pago</u>
                                    </div>
                                    <div>
                                        <ButtonAntd
                                            tipo={1}
                                            style={{ width: "100px" }}
                                            onClick={OpenAgregarT}
                                            children={
                                                <Row
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <span>Nueva</span>
                                                    <AddCard />
                                                </Row>
                                            }
                                        />
                                    </div>
                                </Row>

                                {TarjetasList.length > 0 ? (
                                    <div style={{ width: "200px", display: "flex", alignItems: "center", justifyContent: "space-between", margin: "1% 0" }}>
                                        <img style={{ width: "50px" }} src={TarjPredetermindada.Tipo === "Visa" ? visa : mastercard} alt="" />
                                        <div>
                                            <p>**** **** **** {TarjPredetermindada.UltimosDigitos}</p>
                                            <p style={{ color: "#148f9f", fontSize: "80%", fontWeight: "500" }}>{TarjPredetermindada.TipoTarjeta}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <p>No cuenta con tarjetas agregadas aún</p>
                                )
                                }
                                {/* <u style={{ color: "#148f9f", cursor:"pointer" }}>Cambiar datos de facturación</u> */}
                            </div>
                        </Row>
                        {
                            infoUser.Paquete === "2" && infoUser.PaqueteStatus === 1 ?
                                <div>
                                    <p style={{ fontWeight: "500" }}>Suscripción contratado mediante IOS</p>
                                    <p style={{ fontWeight: "500" }}>Sus recibos de suscripción podra visualizarlos desde un dispositivo IOS</p>
                                </div> : (
                                    <>
                                        <div style={{ background: "white", padding: "1%" }}>
                                            <p style={{ fontWeight: "500" }}>
                                                Recibos de Pago
                                            </p>
                                        </div>
                                        <div>
                                            <ResibosCard recibos={RecibosList} />
                                            {RecibosList.length === 0 && (
                                                <Empty
                                                    description={
                                                        <span style={{ color: "black" }}>Sin recibos</span>
                                                    }
                                                />
                                                // <p className="noCitas">Sin citas</p>
                                            )}
                                        </div>
                                    </>
                                )
                        }
                    </>
                )}
            </Content>


            {/* Modal de cancelacion de sub */}
            {ModalCancelSub}

            {/* AGREGAR TARJETA NUEVA */}
            <Modalagregar
                styleDet={styleAgregarT}
                isOpen={isOpenAgregarT}
                closeModal={CloseAgregarT}
            >
                <div className="Topmodaldetalle">
                    <p>Nueva tarjeta</p>
                    <Close style={{ cursor: "pointer", fontSize: 20 }} onClick={CloseAgregarT} />

                </div>
                {loaderModal ? (
                    <LoaderModals />
                ) : (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div className="contenidomodalA">
                            <img style={{ width: "50px", marginRight: "10px" }} src={visa} alt="" />
                            <img style={{ width: "50px", marginLeft: "10px" }} src={mastercard} alt="" />
                            <form action="" style={{ padding: "0" }} onSubmit={saveTarjeta}>
                                <div style={{ padding: "1% 2%" }}>
                                    {/* <h2 style={{ textAlign: "center", padding: "2.5% 0" }}><b>Nueva tarjeta</b></h2> */}
                                    <div style={{ textAlign: "left" }}>
                                        {/* <p style={{ paddingBottom: "1.5%" }}>Número de tarjeta:</p> */}
                                        <InputAntd
                                            className="inputblue"
                                            value={NumeroTarjeta}
                                            setStateValue={setNumeroTarjeta}
                                            label="Número de tarjeta:"
                                            id="tarjeta"
                                            style={{ margin: "2% 0", width: "100%" }}
                                            placeholder="**** **** **** ****"
                                            setStateError={setMensajeNumeroTarjeta}
                                            textError={[
                                                "Debe escribir un num. de tarjeta",
                                                "Solo puede contener numeros",
                                                "Maximo 16 dígitos",
                                            ]}
                                            type="text"
                                            valueError={MensajeNumeroTarjeta}
                                            vacio={false}
                                            disabled={false}
                                            expresionRegular={expresiones.Numeros}
                                            maxLength={16}
                                        />
                                    </div>
                                    {/* <LeyendaError valido={MensajeNumeroTarjeta} style={{ display: MensajeNumeroTarjeta === "false" ? "flex" : "none" }}>Debe escribir número de tarjeta</LeyendaError> */}
                                    <p style={{ textAlign: "left", paddingBottom: "1.5%" }}>
                                        Fecha de expiración:
                                    </p>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "1.5%",
                                            alignItems: "center",
                                        }}
                                    >
                                        <SelectAntd
                                            // label="Género:"
                                            value={ExpiracionMes}
                                            style={{ width: "100%" }}
                                            placeholder="MM"
                                            options={[
                                                { value: "01", label: "01" },
                                                { value: "02", label: "02" },
                                                { value: "03", label: "03" },
                                                { value: "04", label: "04" },
                                                { value: "05", label: "05" },
                                                { value: "06", label: "06" },
                                                { value: "07", label: "07" },
                                                { value: "08", label: "08" },
                                                { value: "09", label: "09" },
                                                { value: "10", label: "10" },
                                                { value: "11", label: "11" },
                                                { value: "12", label: "12" },
                                            ]}
                                            setStateValue={setExpiracionMes}
                                            setStateError={setMensajeExpiracion}
                                        // valueError={MensajeExpiracion}
                                        // textError={["Debe completar fecha de expiración"]}
                                        />
                                        <p style={{ marginBottom: "2%" }}>/</p>
                                        <Input
                                            value={ExpiracionYear}
                                            style={{ marginBottom: "1%", width: "20%" }}
                                            type="text"
                                            placeholder="AA"
                                            maxLength={2}
                                            onChange={(e) => {
                                                setExpiracionYear(e.target.value);
                                                if (e.target.value.length > 0 && !!ExpiracionMes) {
                                                    setMensajeExpiracion("true");
                                                } else {
                                                    setMensajeExpiracion("false");
                                                }
                                            }}
                                        />
                                    </div>
                                    <LeyendaError
                                        valido={MensajeExpiracion}
                                        style={{
                                            display: MensajeExpiracion === "false" ? "flex" : "none",
                                        }}
                                    >
                                        Debe completar fecha de expiración
                                    </LeyendaError>
                                    <div style={{ textAlign: "left" }}>
                                        <p style={{ paddingBottom: "1.5%" }}>CVV:</p>
                                        <Input
                                            value={CVV}
                                            style={{ marginBottom: "2%", width: "20%" }}
                                            type="text"
                                            placeholder="***"
                                            maxLength={4}
                                            onChange={(e) => {
                                                setCVV(e.target.value);
                                                if (e.target.value.length > 0) {
                                                    setMensajeCVV("true");
                                                } else {
                                                    setMensajeCVV("false");
                                                }
                                            }}
                                        />
                                    </div>
                                    <LeyendaError
                                        valido={MensajeCVV}
                                        style={{
                                            display: MensajeCVV === "false" ? "flex" : "none",
                                        }}
                                    >
                                        Debe escribir código CVV
                                    </LeyendaError>
                                    <Row style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Boton
                                            type="submit"
                                            style={{
                                                width: "100%",
                                                height: "30px",
                                                backgroundColor: "#148f9f",
                                                color: "white",
                                                borderRadius: ".2rem",
                                                cursor: "pointer",

                                            }}
                                        >
                                            Añadir
                                        </Boton>
                                    </Row>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </Modalagregar>

            {/* Modal de elegir tarjeta como metodo de pago */}
            <Modalagregar styleDet={styleAgregarT} isOpen={isOpenSelecTarjeta} closeModal={CloseSelecTarjeta}  >
                <>
                    <div className="Topmodaldetalle">
                        <p>Selecciona nuevo metodo de pago</p>
                        <Close style={{ cursor: "pointer", fontSize: 20 }} onClick={CloseSelecTarjeta} />
                    </div>
                    <div className="contenidomodal">
                        <div style={{ padding: "3%" }}>

                            <TarjetasCard
                                tarjetas={TarjetasList}
                                setIdTarjeta={setIdTarjeta}
                                deleteTarjeta={deleteTarjeta}
                                selectDefaultCard={selectDefaultCard}
                            />
                            {TarjetasList.length === 0 && (
                                <Empty
                                    description={
                                        <span style={{ color: "black" }}>Sin tarjetas</span>
                                    }
                                />
                            )}
                            <div style={{ textAlign: "center" }}>
                            </div>
                        </div>

                    </div>

                </>
            </Modalagregar>

            <SnackbarProvider maxSnack={3}>
                <SnackBar
                    setOpen={setOpen}
                    open={open}
                    typeMessage={typeMessage}
                    message={message}
                />
            </SnackbarProvider>
        </Stack>
    );
}